/**
 * studentRankingViewModel — ce que « Classement » (`<StudentRankingPage>`) lit dans le store.
 *
 * Patron A sans lecture à l'ouverture, comme l'ancien écran (`RankingTabScreen.js`) : les classements
 * sont sur le compte (`rankings`, `rankings_class`, `rank`, `rank_class` de `UserResource`). La
 * flèche relit le compte en demandant des classements frais (`getUser` + `refresh_rankings`), et
 * tourne tant qu'une lecture du compte est en cours (`RankingScreen.js` : `getUser.request`).
 */
import { createSelector } from "reselect"

import {
    isRankingLocked,
    toUIRankingBoards,
    type ApiRankingAccount,
} from "../../../adapters/student/Game/rankingAdapter"
import { type UIRankingBoard } from "../../../ui/types/studentGame"
import { selectDisplayedStudent } from "../../shared/displayedStudent"

export type StudentRankingViewModel = {
    /** `null` tant que le compte n'est pas là. */
    boards: UIRankingBoard[] | null
    /** Sans XP, le classement est fermé. */
    locked: boolean
    loading: boolean
    refreshing: boolean
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type ReduxState = any

const selectStudent = (state: ReduxState): ApiRankingAccount | undefined => selectDisplayedStudent(state)
const selectUserRequesting = (state: ReduxState): boolean => !!state?.api?.getUser?.request

export const studentRankingViewModel = createSelector(
    [selectStudent, selectUserRequesting],
    (account, requesting): StudentRankingViewModel => {
        const boards = toUIRankingBoards(account)
        return {
            boards,
            locked: boards != null && isRankingLocked(account),
            loading: boards == null,
            refreshing: requesting,
        }
    }
)
